(function () {
  'use strict';
  /* snappi chrome for the pages that use layout/theme.liquid: the menu button, the sale clock and the cart count. generated by port_theme.py */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var hdr = $('.hdr'), tog = $('.nav-toggle');
  if (hdr && tog) {
    tog.addEventListener('click', function () { var open = hdr.classList.toggle('open'); tog.setAttribute('aria-expanded', String(open)); });
    $$('.nav a').forEach(function (a) { a.addEventListener('click', function () { hdr.classList.remove('open'); tog.setAttribute('aria-expanded', 'false'); }); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && hdr.classList.contains('open')) { hdr.classList.remove('open'); tog.setAttribute('aria-expanded', 'false'); tog.focus(); } });
  }
  var lines = $$('[data-cd-line]');
  var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
  function fmt(ms) { var t = Math.floor(Math.max(0, ms) / 1000), d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60; return (d > 0 ? d + 'd ' : '') + p2(h) + ':' + p2(m) + ':' + p2(s); }
  /* the sale clock counts down to the visitor's own next local midnight and starts again every day (his call, 18 Oct) */
  function tick() { var e = new Date(); e.setHours(24, 0, 0, 0); var txt = fmt(e.getTime() - Date.now()); lines.forEach(function (n) { if (n.textContent !== txt) { n.textContent = txt; } }); }
  if (lines.length) { tick(); setInterval(tick, 1000); }
  var badge = $('.cart-n'), cb = $('.cart-btn');
  if (badge && window.fetch) {
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0;
      (c.items || []).forEach(function (it) { if (!(it.properties && it.properties._gift === '1') && it.handle !== 'shipping-protection') { n += it.quantity; } });
      badge.hidden = !n; badge.textContent = String(n);
      if (cb) { cb.setAttribute('aria-label', n ? 'cart, ' + n + (n === 1 ? ' item' : ' items') : 'cart, empty'); }
    }).catch(function () {});
  }
})();
